/*
 * Copyright (c) 2023 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {makeStyles} from '@material-ui/core';
import isUndefined from 'lodash.isundefined';
import {translate} from '@ion/core/src/locale/locale';
import {DownloadJobTasksElem} from '@ion/core/src/types/entities';
import Tooltip from '@ion/dls/src/components/tooltip/Tooltip';
import {dlsColor} from '@ion/dls/src/theme/theme';

export interface JobTaskOrderProps {
  row: DownloadJobTasksElem;
  taskOrder?: number;
  taskEndOrder?: number;
  isJobView?: boolean;
};

const useStyles = makeStyles(() => ({
  taskContent : {
    color : ({
      isJobView
    }: JobTaskOrderProps) => !isJobView ? dlsColor('aaBlue') : dlsColor('black'),
    fontSize  : '14px',
    textAlign : 'center'
  }
}));

/**
 * The JobTaskOrder displays the order of task...
 *
 *    import {JobTaskOrder} from '@ion/applications/src/components/jobs/JobTaskOrder';
 *
 *    <JobTaskOrder />
 *
 */
export const JobTaskOrder = ({
  row,
  taskOrder,
  taskEndOrder,
  isJobView = false
}: JobTaskOrderProps) => {
  const classes              = useStyles({isJobView});
  const {task}               = row || {};
  const dependency           = task?.metaData?.dependency?.index;
  const path                 = 'jobcreate:';
  const multipleTask         = translate(`${path}taskOrderInfo`, {taskOrder: 1, taskEndOrder});
  const dependentTaskMessage = translate(`${path}dependentTask.tooltipText`, {dependentTask: Number(dependency)+1});
  const tooltipMessage       = !isUndefined(dependency) ? dependentTaskMessage : multipleTask;

  return (
    <Tooltip arrow placement={'bottom'}
      disableHoverListener={taskEndOrder === 1}
      title={<span>{tooltipMessage}</span>}>
      <div className={classes.taskContent}>{translate(`${path}taskOrder`, {taskOrder})}</div>
    </Tooltip>
  );
};

export default JobTaskOrder;
